import styled from 'styled-components/macro';
import {useState} from "react";
import {
    Button,
    Checkbox,
    FormControl,
    FormErrorMessage,
    FormHelperText,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Textarea
} from "@chakra-ui/react";
import {useHistory} from "react-router-dom";
import {useFeedback} from "../store/feedback";
import {useCreateFeed} from "../api/custom_feeds";

const FeedType = styled.div`
  display: flex;
  cursor: pointer;
`;
const FeedText = styled.div`
  margin-left: 24px;
  display: flex;
  flex-direction: column;

  p {
    font-size: 14px;
  }
`;

const CreateFeed = styled(({onClose}) => {
    const {error, feedbackCh} = useFeedback();
    const [feed, setFeed] = useState({
        name: '',
        description: '',
        isPublic: false,
        includeAll: false,
    });
    const set = (name) => (value) => setFeed((feed) => ({...feed, [name]: value}));

    const [posting, setPosting] = useState(false);
    const createFeed = useCreateFeed(feedbackCh);
    const history = useHistory();

    const [page, setPage] = useState(1);

    const handleCreate = async () => {
        setPosting(true);
        try {
            const {feeds} = await createFeed(feed.name, feed.description, feed.isPublic, feed.includeAll);
            onClose();
            history.push(`/feed/${feeds[0].id}/${feeds[0].slug}/`);
        } catch {
            setPage(1);
        }
        setPosting(false);
    };

    const handlePaginate = async () => {
        if (page === 1) {
            setPage(page + 1);
        } else {
            await handleCreate();
        }
    };

    return (
        <>
            <Modal
                isOpen
                onClose={onClose}
                size={'xl'}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Create a feed</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>

                        <Stack spacing={'5'}>

                            {page === 1 ?

                                <>
                                    <FormControl>
                                        <FormLabel>Feed Name</FormLabel>
                                        <Input placeholder="Cats" value={feed.name}
                                               onChange={(e) => set('name')(e.currentTarget.value)}/>
                                    </FormControl>

                                    <FormControl>
                                        <FormLabel>Describe your feed.</FormLabel>
                                        <Textarea placeholder="A feed which only contains cats."
                                                  value={feed.description}
                                                  onChange={(e) => set('description')(e.currentTarget.value)}/>
                                        <FormHelperText>Recommended if your feed is public.</FormHelperText>
                                    </FormControl>

                                    <FormControl>
                                        <Checkbox size='sm' value={feed.isPublic}
                                                  onChange={(e) => set('isPublic')(e.target.checked)}>Allow other users
                                            to find and use this feed.</Checkbox>
                                    </FormControl>

                                    <FormControl isInvalid={error}>
                                        <FormErrorMessage>{error?.toString()}</FormErrorMessage>
                                    </FormControl>

                                </>
                                :

                                <>
                                    <FeedType onClick={() => set('includeAll')(false)}>
                                        <Checkbox size='lg' isChecked={!feed.includeAll}
                                                  onChange={(e) => set('includeAll')(e.target.checked)}/>

                                        <FeedText>
                                            <h2>Blank Canvas</h2>
                                            <p>A feed made up of nothing but communities, topics, keywords, users, and
                                                domains that you want to see.</p>
                                        </FeedText>

                                    </FeedType>
                                    <FeedType onClick={() => set('includeAll')(true)}>
                                        <Checkbox size='lg' isChecked={feed.includeAll}
                                                  onChange={(e) => set('includeAll')(!e.target.checked)}/>
                                        <FeedText>
                                            <h2>Filter Out</h2>
                                            <p>Everything will be included, except communities, topics, keywords, users,
                                                and domains that you filter out.</p>
                                        </FeedText>

                                    </FeedType>
                                </>
                            }
                        </Stack>

                    </ModalBody>

                    <ModalFooter>
                        <Button variant="cancel" mr={3} onClick={onClose}>Cancel</Button>
                        <Button variant="blue" isLoading={posting} onClick={handlePaginate}>
                            {page === 1 ? 'Next' : 'Create'}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
})``;

export default CreateFeed;
